import { render } from "./readMoreAboutJob.vue?vue&type=template&id=21118e09&ts=true"
import script from "./readMoreAboutJob.vue?vue&type=script&lang=ts"
export * from "./readMoreAboutJob.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__